export default {
      id: "icon--add-blue-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--add-blue-usage",
      toString: function () {
        return this.url;
      }
    }